import { useGlobals } from "@/utils/globals";
import { RumInit } from "@maersk-global/telemetry-web-sdk";
import { getEnvConfig, Environment } from "@/config/envConfig.ts";
import { useUserProfileStore } from "@/modules/userProfile/store/userProfileStore";

let _rumInstance: Record<string, any>;

export function rumInit() {
  // do not create if instance is already created
  if (_rumInstance) {
    return;
  }

  const { version } = useGlobals();
  const ENV_CONFIG = getEnvConfig();
  const userProfileStore = useUserProfileStore();
  const userProfileData = userProfileStore.userProfile;

  // documentation: https://docs.mop.maersk.io/rum/quickstart/getting-started/index.html
  const rumConfig = {
    app: {
      name: ENV_CONFIG.rumAppName,
      environment: ENV_CONFIG.rumAppEnv,
      version
    },
    apiKey: ENV_CONFIG.rumApiToken,
    useSendBeacon: true,
    performanceInstrument: {
      ignoreEvents: ["msal.*", ".*vue.*"]
    },
    propagateTraceHeaderCorsUrls: [
      /^https:\/\/legalfrontdoorapp-(requestregisterservice|requestresolverservice|adminservice)(dev|pp)\.westeurope\.(dev|prod)\.maersk\.io\/?$/
    ], // Back-end APIs for all envs
    ignoreUrls: [`http://localhost:5001/`, `https://legalfrontdoorapp-ui.westeurope.dev.maersk.io/`],
    traceLog: true,
    instrumentations: {
      interactions: {
        eventNames: ["click"] as (keyof HTMLElementEventMap)[] // list here any event we'd like to be captured
      }
    }
  };

  try {
    if (ENV_CONFIG.name != Environment.LOCAL) {
      _rumInstance = RumInit(rumConfig);
      _setUser({
        id: userProfileData.userId,
        email: userProfileData.mail,
        username: userProfileData.fullName,
        roles: userProfileData.roles,
        department: userProfileData.department,
        country: userProfileData.country,
        regions: userProfileData.officeLocation
      });
    }
  } catch (e) {
    // we added this try-catch block so the app not to break in case of RUM related issues
    // error logs may still appear in the console
  }
}

function _setUser(user: Record<string, any>) {
  if (!_rumInstance) {
    return;
  }
  _rumInstance.api.setUser({
    id: user.id,
    email: user.email,
    username: user.username
  });
}
